import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {IconDirective} from "../../_modules/location/_directives/icon.directive";

@Component({
  selector: 'layout-form-expandable',
  standalone: true,
  templateUrl: './form-expandable.component.html',
  styleUrls: ['./form-expandable.component.scss']
})
export class FormExpandableComponent implements OnInit {

  @Input() expanded: boolean = false;
  @Output() expandedChange = new EventEmitter<boolean>();

  @Input() expandText: string = "Expand";
  @Input() collapseText: string = "Collapse";

  @Output() onExpand = new EventEmitter();
  @Output() onCollapse = new EventEmitter();

  @ViewChild(IconDirective) icon: IconDirective | undefined;
  @ViewChild('button') button: ElementRef | undefined;

  ngOnInit(): void {
    this.setExpanded(this.expanded);
  }

  protected setExpanded(value: boolean) {
    this.expanded = value;
    this.expandedChange.emit(value);

    if (value) {
      this.onExpand.emit();
    } else {
      this.onCollapse.emit();
    }
  }
}
